import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg" {...props}><title>icon/event-1-1</title><path d="M7.5 0C4.46 0 2 2.4 2 5.34c0 1.2.4 2.3 1.1 3.2l3.52 5.94.07.1v.02a1 1 0 00.81.4 1 1 0 00.75-.34h.01l.04-.05c.05-.07.1-.14.13-.22l3.45-5.82c.7-.9 1.12-2.01 1.12-3.23A5.42 5.42 0 007.5 0zm0 8a2.5 2.5 0 110-5 2.5 2.5 0 010 5z" fill="#FFF" fillRule="nonzero" /></svg>);